( function ( $ ) {

	MP.setIcons = function(){

		const $els = $('[data-icon]');

		$els.each( function() {

			const $el = $(this);
			
			if ( $el.find('.has-icon-table').length ) return;
			
			$(this).html(`

				<span class="l-flex has-icon-table">
					<i class="has-icon-icon icon-${$el.data('icon')}">
						${new SvgIcons().render($el.data('icon'),true)}
					</i>
					<span class="has-icon-text">
						${$el.text()}
					</span>
				</span>
			`);
		});

	};

	MP.styledBtn = function(){

		const $btns = $('.t-btn');

		$btns.each( function(){
			const $el = $(this);
			$(this).html(`
				<span class="l-center has-icon-table">
					<span class="has-icon-text">
						${$el.html()}
					</span>
					<i class="t-btn-arr icon-${'arr-s'}">
						${new SvgIcons().render('arr-s')}
					</i>
				</span>
			`);
		});
	};

	MP.tender_menu_arrow = function(){

		const $links = $('.tenders-menu-list a');

		$links.length && $links.each ( function(){
			const $el = $(this);
			$(this).html(`
				<span class="l-flex f-c has-icon-table">
					<span class="l-fg1 has-icon-text">
						${$el.html()}
					</span>
					<i class="t-btn-arr icon-${'arr-s'}">
						${new SvgIcons().render('arr-s')}
					</i>
				</span>
			`);
		});
	};

	MP.spotlightBanner = function(){

		$('.spotlight').each(function(){

			const $el = $(this);

			$textHold = $el.find('.spotlight-text');

			var text = $textHold.text().split(' ');
			text[ text.length - 1 ] = `
			<span class="l-nowrap">
				${text[ text.length - 1 ]}
				<span class="svgIcon icon-arr-s-s">
					${new SvgIcons().render('arr-s-s') }
				</span>
			</span>
			`;
			$textHold.html(text.join(' '));

			$el.append(`
				<svg class="spotlight-tail" preserveAspectRatio="none" viewBox="0 0 100 100">
					<polygon points="0,0 100,0 10,50 100,100 0,100"/>
				</svg>
			`)
		});
	};

	MP.freeTextLiBullets = function(){

		$('.t-freeText ul li').each( function(){
			$(this).prepend(new SvgIcons().render('bullet',true));
		});
	};

	MP.teamFrameMask = function(){

		$('.team-item-frame').each ( function(){
			$(this).append( `
				<svg class="l-spread team-item-frame-mask" preserveAspectRatio="none" viewBox="0 0 100 100">
					<polygon points="0,0 100,0 100,50 50,0 0,50"/>
					<polygon points="0,50 50,100 100,50 100,100 0,100"/>
				</svg>
			`)
		});
	};

}) ( window.jQuery);


// WEBPACK FOOTER //
// ./assets/js/a-decorations.js